import React, { Component } from 'react'
import Outernavbar from './outernavbar.component'
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';

const PrivacyAndTerms = () => {


      const containerStyle = {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
   // maxWidth: '1400px',
    margin: 'auto',
    lineHeight: '2.1',
    background: '#f9f9f9',
    width: '100%',
    fontSize: '23px'
  };

  const containerStyle1 = {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    maxWidth: '1400px',
    margin: 'auto',
    lineHeight: '1.6',
    background: '#f9f9f9',
    width: '100%'
  };

  const headingStyle = {
    color: '#2a2a2a',
  };

  const listStyle = {
    marginLeft: '20px',
  };

  const linkStyle = {
    color: '#007BFF',
    textDecoration: 'none',
  };

    return(<>
        <div style={containerStyle}>
           
            <div style={containerStyle1}>
                <h1 style={headingStyle} >Privacy Policy</h1>
  <p><strong>Last Updated:</strong> June 1, 2025</p>
  <p>At Event Trackit, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you use our services.</p>
  <h2 style={headingStyle}>1. Information We Collect</h2>
  <ul style={listStyle}>
    <li><strong>Personal Information:</strong> Name, email address, phone number, and company name.</li>
    <li><strong>Usage Data:</strong> IP addresses, browser types, and device information.</li>
    <li><strong>Payment Information:</strong> Credit card numbers and billing addresses.</li>
  </ul>
  <h2 style={headingStyle}>2. How We Use Your Information</h2>
  <ul style={listStyle}>
    <li>Provide and improve our services.</li>
    <li>Process transactions and manage your account.</li>
    <li>Communicate updates, promotions, and support.</li>
    <li>Analyze usage patterns to enhance the user experience.</li>
  </ul>
  <h2 style={headingStyle}>3. Data Sharing</h2>
  <p>We do not sell or rent your personal information. We may share your data with trusted third-party service providers.</p>
  <h2 style={headingStyle}>4. Data Security</h2>
  <p>We implement industry-standard measures to protect your personal data.</p>
  <h2 style={headingStyle}>5. Your Rights</h2>
  <ul style={listStyle}>
    <li>Access your data</li>
    <li>Request corrections</li>
    <li>Withdraw consent</li>
    <li>Request deletion</li>
  </ul>
  <p>Email: <a href="mailto:support@eventtrackit.com">support@eventtrackit.com</a></p>
  <h2 style={headingStyle}>6. Cookies</h2>
  <p>We use cookies to enhance your experience. You can disable cookies via browser settings.</p>
  <h2>7. Children's Privacy</h2>
  <p>We do not knowingly collect personal information from children under 13.</p>
  <h2>8. Changes to This Policy</h2>
  <p>We may update this policy and post the revised version here.</p>
  <h2 style={headingStyle}>9. Contact Us</h2>
  <p>
    Event Trackit<br/>
    Email: <a href="mailto:support@eventtrackit.com" style={linkStyle}>support@eventtrackit.com</a><br/>
    Website: <a href="https://eventtrackit.com" target="_blank" style={linkStyle}>eventtrackit.com</a>
  </p>

  <hr/>
  <h1 style={headingStyle}>Terms of Service</h1>
  <p>This section is under development. Please check back soon for our full Terms of Service.</p>
  <p>For any inquiries, contact us at <a href="mailto:support@eventtrackit.com" style={linkStyle}>support@eventtrackit.com</a>.</p>
            </div>
        </div>
   </> );
};

export default PrivacyAndTerms;
